import { createAsyncThunk } from "@reduxjs/toolkit";
import { getContractNoteList } from "../../../helpers/fakebackend_helper";



export const contractNote_listThunk = createAsyncThunk("contractNote_listThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getContractNoteList( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










